<template>
  <el-main class="materialwrap">
    <div class="mybread">
      <p><i class="el-icon-location"></i>当前位置：</p>
      <el-breadcrumb separator-class="el-icon-arrow-right">
        <el-breadcrumb-item :to="{ path: '/author' }">账号管理</el-breadcrumb-item>
        <el-breadcrumb-item>{{ pathtype }}账号</el-breadcrumb-item>
      </el-breadcrumb>
    </div>

    <div class="form myform">
      <div class="formtitle">基本信息</div>
      <el-form ref="form" :model="form" :rules="rules" label-width="120px" label-position="left">
        <ul class="form-ul">
          <li>
            <el-form-item label="用户名:" prop="nickname">
              <el-col :span="10">
                <el-input style="width: 400px;" placeholder="请输入企业邮箱" maxlength="30" v-model="form.nickname" clearable />
              </el-col>
            </el-form-item>
          </li>
          <li>
            <el-form-item label="密码:" prop="user_pwd">
              <el-col :span="10">
                <el-input style="width: 400px;" placeholder="请输入英文或字符或数字，默认123456" maxlength="30" v-model="form.user_pwd"
                  clearable />
              </el-col>
            </el-form-item>
          </li>
        </ul>

        <ul class="form-ul">
          <li>
            <el-form-item label="员工编号:" prop="user_no">
              <el-col :span="10">
                <el-input style="width: 400px;" placeholder="请输入员工编号" maxlength="30" v-model="form.user_no" clearable />
              </el-col>
            </el-form-item>

            <el-form-item label="中文名:" prop="realname">
              <el-col :span="10">
                <el-input style="width: 400px;" placeholder="请输入中文" maxlength="30" v-model="form.realname" clearable />
              </el-col>
            </el-form-item>

            <el-form-item label="部门:" prop="dep_id">
              <!-- <el-col :span="10">
                <el-input style="width: 400px;" placeholder="" maxlength="30" v-model="form.department" clearable />
              </el-col> -->
              <el-col :span="10">
                <el-select v-model="form.dep_id" placeholder="请选择" style="margin-right: 0; width: 400px;"
                  @change="departChange" clearable filterable>
                  <el-option :label="`${v.en_name}`" :value="v.id" v-for="(v, i) in departList" :key="i"></el-option>
                </el-select>
              </el-col>
            </el-form-item>

            <el-form-item label="职级:" prop="position_id">
              <el-col :span="10">
                <el-select v-model="form.position_id" placeholder="请选择" style="margin-right: 0; width: 400px;" clearable
                  filterable>
                  <el-option :label="`${v.name}`" :value="v.id" v-for="(v, i) in positionList" :key="i"></el-option>
                </el-select>
              </el-col>
            </el-form-item>

            <el-form-item label="性别：" prop="sex">
              <el-col :span="10">
                <el-radio-group v-model="form.sex" style="margin-right: 0; width: 400px;">
                  <el-radio label="1">男</el-radio>
                  <el-radio label="2">女</el-radio>
                </el-radio-group>
              </el-col>
            </el-form-item>

            <el-form-item label="婚姻状况：" prop="marital_status">
              <el-col :span="10">
                <el-radio-group v-model="form.marital_status" style="margin-right: 0; width: 400px;">
                  <el-radio label="1">未婚</el-radio>
                  <el-radio label="2">已婚</el-radio>
                </el-radio-group>
              </el-col>
            </el-form-item>

            <el-form-item label="是否正式员工：" prop="is_regular_employee">
              <el-col :span="10">
                <el-radio-group v-model="form.is_regular_employee" style="margin-right: 0; width: 400px;">
                  <el-radio label="1">实习</el-radio>
                  <el-radio label="2">正式</el-radio>
                </el-radio-group>
              </el-col>
            </el-form-item>

          </li>
          <li>
            <el-form-item label="手机号:" prop="phone">
              <el-col :span="10">
                <el-input style="width: 400px;" placeholder="" maxlength="30" v-model="form.phone" clearable />
              </el-col>
            </el-form-item>
            <el-form-item label="英文名:" prop="en_name">
              <el-col :span="10">
                <el-input style="width: 400px;" placeholder="" maxlength="30" v-model="form.en_name" clearable />
              </el-col>
            </el-form-item>
            <el-form-item label="职位:" prop="level">
							<el-col :span="10">
								<el-select v-model="form.level" placeholder="请选择" style="margin-right: 0; width: 400px;"
									filterable>
									<el-option :label="`${v.role_name}`" :value="v.id" v-for="(v, i) in roleList"
										:key="`lv_${i}`"></el-option>
								</el-select>
							</el-col>
						</el-form-item>
            <el-form-item label="入职时间：" prop="hire_date">
              <el-col :span="10">
                <el-date-picker v-model="form.hire_date" type="date" value-format="yyyy-MM-dd" style="margin-right: 0; width: 400px;">
                </el-date-picker>
              </el-col>
            </el-form-item>
          </li>
        </ul>

        <ul class="form-ul">
          <li>
            <el-form-item label="发布状态:" prop="status">
              <el-col>
                <el-radio-group v-model="form.status" @change="statusChange">
                  <el-radio label="1">启用</el-radio>
                  <el-radio label="2">停用</el-radio>
                </el-radio-group>
              </el-col>
            </el-form-item>
          </li>
        </ul>

        <el-form-item label="">
          <el-col>
            <el-button @click="resetForm('form')">取消</el-button>
            <el-button type="primary" @click="submitForm('form')">保存</el-button>
          </el-col>
        </el-form-item>
      </el-form>
    </div>

    <el-dialog title="异常提醒" :visible.sync="ceaseShow" width="500px">
      <ul class="aul" style="padding:0">
        <li>
          该用户存在未完成的交接，无法停用账号！
        </li>
      </ul>
      <span slot="footer" class="dialog-footer">
        <el-button @click="cancelCease">取 消</el-button>
        <el-button type="primary" @click="toCeaseFn()">查 看</el-button>
      </span>
    </el-dialog>
  </el-main>
</template>

<script>
import * as api from '@/api'
// 参数：uid 后台用户id(编辑时不为空)，nickname 用户名，user_pwd 用户密码(编辑时如果填写则为修改密码)，en_name 英文名，
// realname 中文名，phone 手机号，department 部门，position 职位，leader 直属领导，
// level 账号权限(2HR 3项目执行 4项目主管 5财务 6高管)，status 发布状态(1启用 2停用)，info 账号备注，option 操作(1新增 2编辑)
export default {
  name: 'anthordetail',
  data() {
    return {
      nodeLimtList: [],
      userList: [],
      departList: [],
      positionList: [],
      handoverList: [],
			roleList: [],
      form: {
        user_no: '',
        nickname: '',
        user_pwd: '',
        en_name: '',
        realname: '',
        phone: '',
        dep_id: '',
        department: {},
        position_id: '',
        position: {},
        leader: '',
        level: '3',
        status: '1',
      },
      type: 0,
      w: 469,
      h: 676,
      rules: {
        nickname: [
          {
            required: true,
            message: '请输入用户名',
            trigger: 'change',
          },
        ],
        user_pwd: [
          {
            required: false,
            message: '请输入密码',
            trigger: 'change',
          },
        ],
        user_no: [
          {
            required: true,
            message: '请输入员工编号',
            trigger: 'change',
          },
        ],
        phone: [
          {
            required: true,
            message: '请输入手机号',
            trigger: 'change',
          },
        ],
        realname: [
          {
            required: true,
            message: '请输入中文名',
            trigger: 'change',
          },
        ],
        dep_id: [
          {
            required: true,
            message: '请输入部门',
            trigger: 'change',
          },
        ],
        position_id: [
          {
            required: true,
            message: '请输入职位',
            trigger: 'change',
          },
        ],
        status: [
          {
            required: true,
            message: '请选择发布状态',
            trigger: 'change',
          },
        ],
        level: [
          {
            required: true,
            message: '请选择职位',
            trigger: 'change',
          },
        ],
        sex: [
          {
            required: true,
            message: '请选择性别',
            trigger: 'change',
          },
        ],
        marital_status: [
          {
            required: true,
            message: '请选择婚姻状况',
            trigger: 'change',
          },
        ],
        hire_date: [
          {
            required: true,
            message: '请选择入职时间',
            trigger: 'change',
          },
        ],
        is_regular_employee: [
          {
            required: true,
            message: '请选择是否正式员工',
            trigger: 'change',
          },
        ],
      },
      ceaseShow: false,
    }
  },
  created() {
    // console.log(this.$route)
    this.query = this.$route.query
    this.type = this.form.type = this.$route.query.type
    this.query.id ? this.getDetail(this.query.id) : this.getDepartList()
  },
  mounted() {
    this.getUserList()
    this.getPositionList()
  },
  watch: {
    type(a) {
      if (a) {
        this.w = this.dd.size[this.type].w
        this.h = this.dd.size[this.type].h
      }
    },
    ['form.phone'](val) {
      if (val != undefined) {
        this.$nextTick(() => {
          this.form.phone = val.replace(/\D/g, '');
        });
      }
    },
  },
  methods: {
    checkUrlFn() {
      // 获取当前URL的哈希部分  
      const hash = window.location.hash;  
      // 移除'#'字符  
      const url = hash.substring(1); 
      
      let postData = {
        url_path: url
      }
      api.checkLoginUrl(postData).then((res) => {
        if (res.status == 400) {
          this.$message({
            type: 'info',
            message: '暂无权限',
          })
          this.$router.push({
            path: `/home`
          });
        }
      })
    },
    checkNodeFn(menu_id) {
      let postData = {
        menu_id,
      }
      api.checkNode(postData).then((res) => {
        this.nodeLimtList = res.node_ids.split(',')
      })
    },
    NodeInclude(val) {
      return this.nodeLimtList.includes(val)
    },
    formatInput(e, key) {
      console.log(e, key)
      if (e.replace(/\D/g, '') == 0 && key == 'price') {
        this.$message.error('请输入大于0的整数')
        return false
      }
      this.form[key] = e.replace(/\D/g, '')
      // node[key] =
    },
    sortFn(arr, key, flag) {
      arr.sort((m, n) => (!flag ? (m[key] - n[key]) : (n[key] - m[key])))
      return arr
    },
		getRoleList(dep_id) {
			return new Promise((resolve) => {
				this.$fly
					.post('ApiRole_getRoleList.html', {
						per_page: 5000,
            dep_id
					})
					.then((res) => {
						this.roleList = res.filter((item) => { return item.role_name != '超管' })
						resolve(res)
					})
			})
		},
    async getPositionList() {
      return new Promise((resolve) => {
        this.$fly
          .post('apiAccount_getPositionList.html', {

          })
          .then((res) => {
            this.positionList = res
            resolve(res)
          })
      })
    },
    async getDepartList() {
      return new Promise((resolve) => {
        this.$fly
          .post('apiAccount_getDepartmentList.html', {

          })
          .then((res) => {
            this.departList = res
            resolve(res)
          })
      })
    },
    async getUserList() {
      this.$fly
        .post('apiAccount_getUserList.html', {
          per_page: 5000,
        })
        .then((res) => {
          this.userList = res.itemList
        })
    },
    getHandoverList(uid) {
      this.$fly
        .post('apiAccount_getProjectHandoverList.html', {
          user_id: uid
        })
        .then((res) => {
          this.handoverList = res
        })
    },
    departChange(v) {
      this.form.level = ''
      this.getRoleList(v)
    },
    async getDetail(id) {
      this.checkUrlFn()
      this.checkNodeFn('61')
      api.getAccountDetail({
          uid: id,
        })
        .then((res) => {
          console.log(res);
          const {
            nickname,
            // user_pwd,
            realname,
            en_name,
            user_no,
            phone,
            dep_id,
            department,
            position_id,
            position,
						level,
            status,
            sex,
            hire_date,
            is_regular_employee,
            marital_status,
          } = res.bkUserArr
          this.form = {
            uid: id || '',
            nickname,
            user_pwd: '',
            realname,
            en_name,
            user_no,
            phone,
            dep_id,
            department,
            position_id,
            position,
						level,
            status,
            sex,
            hire_date,
            is_regular_employee,
            marital_status,
          }
          this.query.id ? this.form.user_pwd = '****' : this.form.user_pwd = ''
          this.getDepartList().then(() => {
            this.getRoleList(this.form.dep_id)
          })
          this.getHandoverList(this.form.uid)
          return res
        })
    },
    submitForm(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.addUpdateUser()
        } else {
          console.log('error submit!!')
          return false
        }
      })
    },
    addUpdateUser() {
      this.form.option = this.form.uid ? '2' : '1'
      if (this.form.option == '2' && this.form.user_pwd == '****') {
        this.form.user_pwd = ''
      } else if (this.form.option == '1' && this.form.user_pwd == '') {
        this.form.user_pwd = '123456'
      }
      // let reg = /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)[^]{8,16}$/;
      // if (this.form.user_pwd != '' && !reg.test(this.form.user_pwd)) {
      //   this.$message.error('密码必须为包含大小写字母、英文特殊字符、数字的至少8位字符')
      //   return false
      // }
      const tempForm = JSON.parse(JSON.stringify(this.form))
      delete tempForm.department
      delete tempForm.position
      api.addUpdateUser({
        ...tempForm,
        dep_id: this.form.dep_id,
        position_id: this.form.position_id,
      }).then(() => {
        this.$message.success('success')
        this.$router.go(-1)
      })
    },
    resetForm(formName) {
      this.$refs[formName].resetFields()
      this.$router.go(-1)
    },
    statusChange() {
      const handoverList = this.handoverList
      console.log(handoverList.length);
      if (this.form.status == '2' && handoverList.length) {
        this.ceaseShow = true
      }
    },
    cancelCease() {
      this.ceaseShow = false
      this.form.status = '1'
    },
    toCeaseFn() {
      this.$router.push({
        path: '/author/view',
        query: { id: this.query.id },
      })
    },
  },
}
</script>

<style lang="scss" scoped>
.link {
  color: $c;
}

.el-checkbox-group {
  display: flex;
  flex-flow: row wrap;

  .el-checkbox {
    width: 40%;
    flex: none;
    padding: 10px 0;
  }
}

.dimg {
  font-size: 12px;
  margin: 25px 0 0 0;

  &::before {
    font-size: 40px;
  }

  p {
    padding: 10px 0;
  }

  span {
    color: #999;
  }
}

.el-form-item {
  margin-bottom: 30px;
}

.materialwrap {
  .form.myform {
    padding-left: 100px;
  }

  .filterwrap {
    display: flex;
    justify-content: flex-end;
    padding: 0 0 15px 0;

    .el-button {
      margin: 0 0 0 20px;
    }
  }

  .apage {
    background: #f2f2f2;
    padding: 8px;
    text-align: right;
  }

  .el-select {
    margin-right: 20px;
  }

  .el-tag {
    margin-right: 10px;
    margin-bottom: 10px;
    height: 36px;
    line-height: 36px;
    border: none;
  }

  .form {
    @extend %box;
    padding: 30px;
    margin-bottom: 20px;
  }

  .table {
    @extend %box;
    padding: 30px;
  }

  .line {
    text-align: center;
  }

  .group-head {
    font-size: 18px;
    font-weight: 700;
    padding-left: 10px;
    color: #10456d;
  }
}

.formtitle {
  position: relative;
  left: -50px;
  margin-bottom: 30px;
  font-size: 28px;
  line-height: 48px;
  font-weight: 600;
}

.form-ul {
  display: flex;
  flex-flow: row wrap;
  justify-content: space-between;
  align-items: flex-start;
  width: 80%;
  padding: 0 20px 32px;
  border-radius: 20px;
  margin-bottom: 30px; 
  background: #f2f2f2;
  li {
    padding: 32px 0 0;
    .el-form-item {
    &:nth-last-child(1) {
      margin-bottom: 0;
    }
  }
  }
}
</style>
